// 支持多个倒计时容器的通用倒计时逻辑
function startCountdown(endDate, containerSelector, endText = "End of event") {
  // 获取容器元素
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // 获取时间显示元素
  const daysEl = container.querySelector(".days");
  const hoursEl = container.querySelector(".hours");
  const minutesEl = container.querySelector(".minutes");
  const secondsEl = container.querySelector(".seconds");

  function updateCountdown() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      clearInterval(countdownInterval);
      container.innerHTML = `<div>${endText}</div>`;
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (daysEl) daysEl.innerText = days.toString().padStart(2, "0");
    if (hoursEl) hoursEl.innerText = hours.toString().padStart(2, "0");
    if (minutesEl) minutesEl.innerText = minutes.toString().padStart(2, "0");
    if (secondsEl) secondsEl.innerText = seconds.toString().padStart(2, "0");
  }

  updateCountdown();
  const countdownInterval = setInterval(updateCountdown, 1000);
}

// 美国中部时间 7月11日 23:59:59
const eventEndDate = new Date("2025-07-11T23:59:59-06:00").getTime();

// 启动普通倒计时
startCountdown(eventEndDate, ".countdown-timer-container");

// 启动迷你倒计时
startCountdown(eventEndDate, ".mini-countdown-timer-container");
